import { Image, Style } from  '@/imports-files/components/subsidebar-list-item';
import Check from '/public/images/logo/check.png';
import {default as DropdownIcon} from '/public/icons/dropdownicon.svg';
import {default as DropupIcon} from '/public/icons/dropupicon.svg';
import {setSubMenuStatus, redirectToOtherPage, activateOption, redirectToOtherStep, mobileActivateOption, activeOnHover} from '@/actions/components/subSidebarListItemWithSubMenu';
import { useQueryClient, useRouter} from '@/imports-files/hooks/use-navbar';
import { useNavbarStatus } from '@/hooks/use-navbar';
import { ADMIN } from '@/constants/components/sidebar';

export function SubSidebarListItem(props)
{ 
    return (
              props.options != null ? <Sidebar userRole     =   {props.userRole} 
                                               currentRole  =   {props.currentRole}
                                               options      =   {props.options} 
                                               setPageKey   =   {props.setPageKey}/> : props.options 
           )
}

function ProgressingDots()
{
  return(
          <div className={Style.SubSidebar__DotsSection}>
              <Image src="/images/components/sidebar/dots.png" alt="" height='10px' width='2px'/>
          </div>
        )
}

export function SubSidebarListItemWithSubMenu(props)
{

 
  return (
            props.options != null ? <Subsidebar options                   =   {props.options} 
                                                userRole                  =   {props.userRole} 
                                                currentRole               =   {props.currentRole}
                                                setSubsidebarOptions      =   {props.setSubsidebarOptions}
                                                setPageKey                =   {props.setPageKey}/> 
                                  : props.options
         )
}

export function MobileSubSidebarListItem(props)
{ 
    return (
              props.options != null ? <MobileSidebar  options                   =   {props.options} 
                                                      setSubSubSidebarOptions   =   {props.setSubSubSidebarOptions}
                                                      userRole                  =   {props.userRole} /> 
                                    : props.options 
           )
}


export function MobileSubSidebarListItemWithSubMenu(props)
{
  return (
            props.options != null ? <MobileSubsidebar userRole                  =   {props.userRole} 
                                                      options                   =   {props.options} 
                                                      setSubSubSidebarOptions   =   {props.setSubSubSidebarOptions}
                                                      /> 
                                  : props.options
         )
}

function Sidebar(props)
{
  const queryClient =   useQueryClient();
  const router      =   useRouter();

  const currentPath = router.asPath;
  

  return(
          Object.keys(props.options).map((value, index) => {
            return(
                    isOptionVisibleToUser(props,value) && <div key        = {index} 
                         className  = {`SubSidebarItem ${Style.SubSidebar__Section}`}  
                         data-item-title = {value}>

                        {/* index !=0 ? ProgressingDots() : '' */}
                        
                        <div className       =   {`${Style.SubSidebar__Item}` }
                             onMouseEnter    =   {(event) => { activeOnHover(event, queryClient, props.options[value], router) }} 
                             onClick         =   {(event) => { redirectToOtherStep(event, queryClient, props.options[value], router )}}>
                          
                            <div className={` ${Style.SubSidebar__Bullet}`}>
                                <div className="SubSidebarItem__Checked" >
                                  {/* <Image src={Check} alt=""/> */}
                                </div>
                                <span className="SubSidebarItem__Bullets">&nbsp;</span>
                            </div>
                            
                            <div className='SubSidebarItemText'>{props.options[value].title}</div>
                        </div>

                        
                    
                    </div>
                  )
                })
        )
}

function Subsidebar(props)
{ 
  const queryClient =   useQueryClient();
  const router      =   useRouter();
  const {navbarStatus, updateNavbarStatus } = useNavbarStatus();

  return(
          Object.keys(props.options).map((value, index) => {
              return(
                      isOptionVisibleToUser(props,value) ? 
                      <div key = {index} item-index={index} className = {`SubSidebarItem ${Style.SubSidebar__Section} Close ParentSubSidebarItem`} onClick={ (event) => setSubMenuStatus(event, queryClient)}>
                        
                          { 
                            props.options[value].subSidebar_options ?
                            <div className={` ${Style.SubSidebar__Item}`}>
                              <div className='SubSidebarItemText SubSidebarDropdownText' data-item-title={value} >{props.options[value].title}
                              <div className={`DropdownIcon ${Style.SubSidebar__DropdownIcon}`} data-item-title={value} > <DropdownIcon /> </div>
                              <div className={`DropupIcon ${Style.SubSidebar__DropupIcon}`} data-item-title={value} > <DropupIcon /> </div> </div>
                            </div>
                            :
                            <div className={` ${Style.SubSidebar__MenuItem} ChildSubSidebarItem WithoutChildren`}>
                              
                                <div  className           =   'SubSidebarItemText'  
                                      data-item-title     =   {value} 
                                      onClick             =   { (event) => { redirectToOtherPage( props.options[value], router, navbarStatus, updateNavbarStatus) } }> 
                                      {props.options[value].title} 
                                </div>
                            
                            </div>
                          }

                          { 
                            isOptionVisibleToUser(props,value) && props.options[value].subSidebar_options != undefined ?
                            <div className={`${Style.SubSidebar__MenuSection} ChildSubSidebarItem`}>

                                { SubSidebarListItemWithSubMenu({ 'options'                 : props.options[value].subSidebar_options, 
                                                                  'userRole'                : props.userRole,
                                                                  'currentRole'             : props.currentRole,
                                                                  'setSubSubSidebarOptions' : props.setSubSubSidebarOptions,
                                                                  'setPageKey'              : props.setPageKey }) }
                            </div> : ''
                          }
                        
                      </div>
                      :''
                    )
                })
        )
}

function isOptionVisibleToUser(props,value)
{

  if( props.options[value].title == 'Personal' && props.currentRole == ADMIN)
  {
    return false;
  }
  else if( props.options[value].title == 'My Preferences' && props.currentRole == ADMIN)
  {
    return false;
  }
  else if( props.options[value].title == 'My Integrations' && props.currentRole == ADMIN)
  {
    return false;
  }
  else if( typeof(props.options[value].allowed_user_type) == 'undefined')
  {
    return true;
  }
  else
  {
     return props.options[value].allowed_user_type?.includes(props.userRole);
  }
   
}

function MobileSidebar(props)
{
  const queryClient =   useQueryClient();
  return(
          Object.keys(props.options).map((value, index) => {
            return(
                    <div key = {index} className = {`SubSidebarItem ${Style.SubSidebar__Section}`}>

                    <div className={` ${Style.SubSidebar__Item}`}>
                      <div className={` ${Style.SubSidebar__Bullet}`}>
                          <div className="SubSidebarItem__Checked" >
                            <Image src={Check} alt=""/>
                          </div>
                          <span  className="SubSidebarItem__Bullets">&#8226;</span>
                      </div>
                      <div className  =  'SubSidebarItemText' 
                           data-item-title      =  {value} 
                           onClick    =  { () => { redirectToOtherStep( props.options[value]) }}>
                           {props.options[value].title}
                      </div>
                    </div>

                      { index < Object.keys(props.options).length-1 ? ProgressingDots() : ''}
                    </div>
                  )
                })
        )
}


function MobileSubsidebar(props)
{ 
  const queryClient =   useQueryClient();
  return(
  Object.keys(props.options).map((value, index) => {
      return(
              <>
                { isOptionVisibleToUser(props,value) ? 
                <div key = {index} item-index={index} className = {`SubSidebarItem ${Style.SubSidebar__Section} Close ParentSubSidebarItem`} onClick={ (event) => setSubMenuStatus(event, queryClient)}>
                    { 
                      <div className={` ${Style.SubSidebar__Item}`} onClick = { () => { mobileActivateOption(queryClient, value, props.options[value].subSidebar_options, props.setSubSubSidebarOptions)} }>
                        <div className='SubSidebarItemText SubSidebarDropdownText' data-item-title={value} >{props.options[value].title}</div>
                        { props.options[value].subSidebar_options && <div className={`DropdownIcon ${Style.SubSidebar__DropdownIcon}`} data-item-title={value} > <DropdownIcon /> </div>}
                        { props.options[value].subSidebar_options && <div className={`DropupIcon ${Style.SubSidebar__DropupIcon}`} data-item-title={value} > <DropupIcon /> </div> }
                      </div>                  
                    }
                </div>
                : ''}
              </>
            )
        }))
}
